import { TeamMember } from "@entities/team-member";
import { Plus } from "@shared/assets/icons";
import { paths } from "@shared/routing";
import Link from "next/link";
import { forwardRef } from "react";

export type CardProps = {
  teamMember: TeamMember;
  selectable: boolean;
  className?: string;
};

export const Card = forwardRef<HTMLAnchorElement, CardProps>(function Card(
  { teamMember: { id, position, name, image }, selectable, className },
  ref
) {
  return (
    <Link
      ref={ref}
      className={[
        `relative flex flex-col items-center aspect-[0.88] gap-4 bg-gray-200 rounded text-white cursor-pointer transition transform-gpu duration-500 ${!selectable && "pointer-events-none"}`,
        className,
      ].join(" ")}
      href={paths.teamId(id)}
    >
      <div
        className={`absolute w-full h-full max-w-[unset] top-0 left-0 bg-center bg-cover bg-no-repeat rounded`}
        style={{
          backgroundImage: `url(${image})`,
        }}
      ></div>

      <div
        className={`absolute w-full h-full flex flex-col justify-end p-10 gap-2 text-sm transition-colors bg-gradient-to-b ${selectable && "hover:bg-persian-plum-900 hover:bg-opacity-25"} from-transparent via-[#0000000F] to-[#000000FA] rounded`}
      >
        <div className={"flex justify-between"}>
          <p className={"uppercase text-xl"}>{name}</p>

          {selectable && <Plus />}
        </div>

        <p className={"text-base"}>{position}</p>
      </div>
    </Link>
  );
});
